import { Inject, Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgForm } from '@angular/forms'
import Swal from 'sweetalert2';
import { AppSettingService } from '../app.service';
import { UserInfoService } from '../user/user-info.service';
import { AccountAPIService } from '../user/account-api.service';
import { SessionAPIService } from '../user/user-api.service';
import { InstitutionAPIService, InstitutionWelcomeService} from './institution-api.service';
import { SignupLoginDialog } from '../user/signupLogin/signup-login.component';

//#region InstitutionWelcome
@Component({
	templateUrl: './institution-welcome.dialog.html',
	styleUrls: ['./institution-welcome.scss'],
	standalone: false
})
export class InstitutionWelcomeDialog implements OnInit {
	cyberId: string = "0";

	constructor(
		private dialogRef: MatDialogRef<InstitutionWelcomeDialog>,
		@Inject(MAT_DIALOG_DATA) private data: any
	) {
		this.cyberId = data.cyberId ?? "";
	}

	iPage: number = 0;
	iPageHighestReached: number = 0;
	isMobile:boolean = AppSettingService.widgetMobile();
	modalHeight: number = 700;
	modalImage = 'assets/images/institution/airplane-chalkboard.png';

	closeModal():void {
		this.dialogRef.close();
	}

	updateModalImage(): void {
		switch (this.iPage) {
			case 0:
				this.modalImage = 'assets/images/institution/airplane-chalkboard.png';
				break;
			case 1:
				this.modalImage = 'assets/images/institution/interestSurvey.png';
				break;
			case 2:
				this.modalImage = 'assets/images/institution/skillsAssessment.png';
				break;
			case 3:
				this.modalImage = 'assets/images/institution/beginCareerExploration.png';
				break;
			case 4:
				if (this.cyberId === '1') {
					this.modalImage = 'assets/images/institution/CCOEEconomy.png';
				}
				else {
					this.modalImage = 'assets/images/institution/worldAroundMe.png';
				}
				break;
		}
	}

	updateHighest(): void {
		if (this.iPage > this.iPageHighestReached) {
			this.iPageHighestReached = this.iPage;
		}
	}

	next(): void {
		if (this.iPage < 4) {
			this.iPage++;
			this.updateHighest();
		}
		this.updateModalImage();
	}

	jumpTo(i: any): void {
		if (this.iPageHighestReached >= i) {
			this.iPage = i;
			this.updateHighest();
		}
		this.updateModalImage();
	}

	ngOnInit(): void {
		if (window.innerHeight < 750) {
			this.isMobile = true; //do this to force mobile size modal on very small screens that are still desktop mode
		}
		this.modalHeight = .90 * window.innerHeight;
	}
}


@Component({
	selector: "app-institution-welcome",
	template: "",
	standalone: false
})
export class InstitutionWelcomeComponent implements OnInit {
	@Input() cyberId: string = "0";

	constructor(
		private userInfo: UserInfoService,
		private dialog: MatDialog,
		private welcomeSrv: InstitutionWelcomeService
	) { }

	ngOnInit(): void {
		if (this.welcomeSrv.welcomeTourStatus && this.userInfo.isAnonymous()) {
			this.dialog.open(
				InstitutionWelcomeDialog,
				{
					maxWidth: '850px',
					width: '100%',
					panelClass: 'jmDialogPopup',
					data: {
						cyberId: this.cyberId
					}
				}
			);
		}
		this.welcomeSrv.welcomeTourStatus = false;
	}
}
//#endregion InstitutionWelcome


//#region Subscription
@Component({
	templateUrl: './subscription-sample.dialog.html',
	standalone: false
})
export class SubscriptionSampleDialog {
	constructor(
		private dialogRef: MatDialogRef<SubscriptionSampleDialog>,
	) {
	}

	cancel(): void {
		this.dialogRef.close('cancel');
	}

	subscribe(): void {
		this.dialogRef.close('subscribe');
	}
}

@Component({
	templateUrl: './subscription-email.dialog.html',
	standalone: false
})
export class SubscriptionEmailDialog {
	msgType: string = "";
	emailInvalid: boolean = false;
	name: string;

	constructor(
		private accountAPI: AccountAPIService,
		private userInfo: UserInfoService,
		private sessionAPI: SessionAPIService,
		private dialogRef: MatDialogRef<SubscriptionEmailDialog>,
		@Inject(MAT_DIALOG_DATA) private data: any
	) {
		if (this.userInfo.isAnonymous()) {
			dialogRef.close('cancel');
		}
		this.msgType = data.msgType;
		this.msgType = this.msgType == null ? '' : this.msgType.trim();
		this.name = data.name;
	}

	cancel() {
		//emailForm.myEmail.required = false;
		this.dialogRef.close('cancel');
	}

	updateEmail(f: NgForm) {
		if (f == null || f.form.valid !== true) {
			this.emailInvalid = true;
			return;
		}
		this.emailInvalid = false;
		this.accountAPI.updateFullInfo({ Person: { Email: f.form.value.myEmail } }).subscribe(
			response => {
				// update UserInfo
				this.sessionAPI.getSessionInfo().subscribe(
					response => {
						this.dialogRef.close('update');
					},
					error => {
						console.log(error);
						Swal.fire({title: "Oops", html: "Sorry, fail to get new email information. Please retry", icon: "error" });
					}
				);
			},
			response => {
				console.log(response);
				let message = response != null && response.error != null && response.error.Detail != null ? response.error.Detail : "Sorry, fail to update email. Please retry";
				Swal.fire({ title: 'Oops', html: '<center>' + message + '</center>', icon: 'error' });
			}
		);
	}
}

@Component({
	selector: 'app-subscription',
	templateUrl: './subscription.component.html',
	standalone: false
})
export class SubscriptionComponent implements OnInit {
	@Input() name: string = "";
	@Input() source: string = "";
	@Input() sourceId: any = "";

	constructor(
		private userInfo: UserInfoService,
		private institutionAPI: InstitutionAPIService,
		private dialog: MatDialog,
		private route: ActivatedRoute,
		private router: Router
	) { }

	status: number = 0;
	subscription: any = null;
	endableSample: boolean = false;
	enableEmailPrompt: boolean = false;
	private needReload: boolean = false;
	institutionCode: string = '';

	dsiplaySample(): void {
		this.endableSample = true;
		let popup = this.dialog.open(
			SubscriptionSampleDialog,
			{
				maxWidth: '850px',
				width: '100%',
				panelClass: 'jmDialogPopup',
			}
		);
		popup.afterClosed().subscribe(
			choice => {
				if (choice === 'subscribe') {
					this.subscribe();
				}
				else {
					this.status = 1;
				}
				this.endableSample = false;
			}
		);
	};

	noEmail(): void {
		this.promptEmailEntry('noEmail');
	};

	private doSubscribe(): void {
		if (this.userInfo.isAnonymous()) {
			this.status = 1;
			return;
		}
		this.institutionAPI.subscribe(this.institutionCode).subscribe(
			response => {
				this.status = 2;
				this.subscription = response.Object;
				Swal.fire({
					title: '',
					html: '<center>Thanks for subscribing to ' + this.name + ' metrics report! You will now receive valuable reporting data directly in your inbox each month. Don\'t forget to tell your friends at ' + this.name + ' to subscribe as well! <br/><br/>Interested in receiving premium reports? Reach out to <a href="mailto:hi@journeysmap.com">hi@journeysmap.com</a> today to learn how!</center>',
					allowOutsideClick: true,
					showConfirmButton: true
				}).then(choice => {
					if (this.needReload) {
						window.location.reload();
						return;
					}
				});
			},
			error => {
				console.log(error);
				this.status = 1;
				Swal.fire({ title: 'Oops', html: 'Sorry, fail to subscribe. Please retry.', icon: 'error' });
			}
		);
	}

	private promptEmailEntry(msgType: string) {
		this.enableEmailPrompt = true;
		let popup = this.dialog.open(
			SubscriptionEmailDialog,
			{
				minWidth: '400px',
				disableClose: false,
				autoFocus: true,
				data: {
					msgType: msgType,
					name: this.name
				}
			}
		);
		popup.afterClosed().subscribe(
			choice => {
				if (choice === 'update') {
					// to be caution, regardless users have subscribe or not, just do it again
					this.doSubscribe();
					if (msgType === 'noEmail') {
						this.updateStatus()
					}
				}
				else {
					if (this.needReload) {
						window.location.reload();
						return;
					}
					this.status = 1;
				}
				this.enableEmailPrompt = false;
			}
		);
	}

	subscribe(): void {
		this.status = 99;
		if (!this.userInfo.isAnonymous()) {
			if (this.userInfo.getProfile().Email.trim() !== '') {
				this.doSubscribe();
			}
			else {
				this.promptEmailEntry('');
			}
		}
		else {
			// Anonymous and zone not allow signup
			if (!this.userInfo.allowSignup()) {
				this.status = 0;
				return;
			}
			else {
				let popup = this.dialog.open(
					SignupLoginDialog,
					{
						width: "100%",
						height: "100%",
						disableClose: true,
						autoFocus: true,
						panelClass: 'jmSignupLogin',
						data: {
							display: "login",
							globalAccount: false
						}
					}
				);
				// close
				popup.afterClosed().subscribe(
					choice => {
						if (choice !== "cancel") {
							this.needReload = true;
							// see if new user has email
							if (this.userInfo.getProfile().Email.trim() !== '') {
								this.doSubscribe();
								return;
							}
							// prompt for email enter
							else {
								this.promptEmailEntry('');
							}
						}
						else {
							this.status = 1;
						}
					}
				);
			}
		}
	}

	unsubscribe(unsubscribe: string) {
		this.status = 99;
		let passUnscribe = false;
		unsubscribe = unsubscribe == null ? '' : unsubscribe.trim();
		if (unsubscribe !== '') {
			passUnscribe = true;
		}
		else if (this.subscription != null) {
			unsubscribe = this.subscription.Unsubscribe;
		}

		if (unsubscribe === '') {
			this.status = 1;
			return;
		}
		else {
			this.institutionAPI.unsubscribe(unsubscribe).subscribe(
				response => {
					this.status = 1;
					let text = '<center>You are now unsubscribed. We\'d like to think of this more as a see you later rather than goodbye forever.<br /><br />Have suggestions for us that might get you to subscribe again? Shoot them over to <a href="mailto:hi@journeysmap.com">hi@journeysmap.com</a> today!</center>';
					if (response != null && response.Detail != null && response.Detail.toLowerCase() === 'not found') {
						text = '<center>You have already unsubscribed. We\'d like to think of this more as a see you later rather than goodbye forever.<br /><br />Have suggestions for us that might get you to subscribe again? Shoot them over to <a href="mailto:hi@journeysmap.com">hi@journeysmap.com</a> today!</center>';
					}
					Swal.fire({
						title: '',
						html: text,
						allowOutsideClick: true,
						showConfirmButton: true
					}).then(() => {
						// change url to get rid of the unscribe parameter in URl
						if (passUnscribe) {
							this.router.navigateByUrl(window.location.pathname.replace(AppSettingService.baseUrl, ""));
						}
					});
				},
				error => {
					console.log(error);
					this.status = 2;
					Swal.fire({ title: "Oops", html: "Fail to unsubscribe. Please refresh this page.", icon: "error" });
				}
			);
		}
	}

	private checkUnsubscribeUrl(): void {
		let unsubscribe: string = "";
		if (this.route.snapshot.queryParams['UnsubscribeMetricReport']) {
			unsubscribe = this.route.snapshot.queryParams["UnsubscribeMetricReport"];
		}
		if (unsubscribe != null && unsubscribe.trim() !== '') {
			unsubscribe = unsubscribe.trim();
			this.unsubscribe(unsubscribe);
		}
	}

	private updateStatus(): void {
		this.subscription = null;
		if (this.userInfo.isAnonymous()) {
			if (this.userInfo.allowSignup()) {
				this.status = 1;
			}
			else {
				this.status = 0;
			}
			this.checkUnsubscribeUrl();
		}
		else {
			this.institutionAPI.getSubscription(this.institutionCode).subscribe(
				response => {
					if (response.Object == null) {
						this.status = 1;
					}
					else {
						this.status = 2;
						this.subscription = response.Object;
					}
					this.checkUnsubscribeUrl();
				},
				error => {
					console.log(error);
					this.status = 0;
				}
			);
		}
	}

	ngOnInit(): void {
		this.name = this.name == null ? '' : this.name.trim();
		this.source = this.source == null ? '' : this.source.trim();
		this.sourceId = this.sourceId == null ? '' : this.sourceId.trim();
		if (this.source !== '' && this.sourceId !== '') {
			this.institutionCode = this.source + '-' + this.sourceId;
			this.updateStatus();
		}
	}
}
//#endregion Subscription
